import { observable, action } from 'mobx';
import { isDataExist } from 'Utils/dataTools';
import * as services from '../services/inspect';
import { message } from 'antd';
import { omit } from 'lodash';

class Inspect {
	/* 查询页面数据 */
	@observable isLoading = false;
	@observable materialList = [];
	@observable procedureList = [];
	@observable procedureId = '';
	@observable materialId = '';

	@observable maintainList = [];
	@observable maintainPage = { pageIndex: 1, pageSize: 10 };
	@observable maintainType = 4;
	@observable checkedTag = 1;

	/* 弹窗内容 */
	@observable currentMain = {};
	@observable info = {};
	@observable editVisible = false;
	@observable configList = [];
	@observable procedureList = [];

	/* 获取所有的工序列表 */
	@action.bound async getProcedure(params) {
		this.isLoading = true;
		try {
			let res = await services.getRequest(
				services.requestUrl.procedureList,
				params
			);
			this.isLoading = false;
			if (isDataExist(res)) {
				this.procedureList = res.data.data;
			}
		} catch (error) {
			console.log(error);
		}
	}
	/* 获取所有的物料 */
	@action.bound async getAllBom(params) {
		this.isLoading = true;
		try {
			let res = await services.getRequest(
				services.requestUrl.allBomList,
				params
			);
			this.isLoading = false;
			if (isDataExist(res)) {
				this.materialList = res.data.data;
			}
		} catch (error) {
			console.log(error);
		}
	}

	/* 获取所有点检项列表 */
	@action async getSelectAll(type, params) {
		/* 获取列表 */
		this.procedureList = [];
		try {
			let req = type === 'material' ? 'getMaterial' : 'getProcedure';
			let res = await services.getRequest(services.requestUrl[req], params);
			if (isDataExist(res)) {
				if (type === 'material') {
					this.materialList = res.data.data;
				} else {
					this.procedureList = res.data.data;
				}
			}
		} catch (error) {
			console.log(error);
		}
	}

	/* ---------------- 点检库 */
	@action async getDevice() {
		/* 获取所有设备类型 */
		this.isLoading = true;
		try {
			let res = await services.getRequest(services.requestUrl.getDevice);
			this.isLoading = false;
			if (isDataExist(res)) {
				this.deviceList = [{ name: '全部', id: '' }].concat(res.data.data);
				this.deviceType = '';
			}
		} catch (error) {
			console.log(error);
		}
	}
	@action async getMaintain(params = {}) {
		/* 获取列表 */
		this.isLoading = true;
		this.maintainList = [];
		try {
			let res = await services.getRequest(services.requestUrl.getMaintain, {
				...params,
				procedureId:this.procedureId
			});
			this.isLoading = false;
			if (isDataExist(res)) {
				this.maintainList = res.data.data.items;
				this.maintainPage = res.data.data.page;
			}
		} catch (error) {
			console.log(error);
		}
	}

	/* 表格操作 */
	@action async removeMaintain(params) {
		try {
			let data = {
				...params
			};
			let res = await services.putRequest(
				services.requestUrl.singleRemove,
				data
			);
			if (isDataExist(res)) {
				message.success('删除成功');
			}
		} catch (error) {
			console.log(error);
		}
		this.getMaintain();
	}
	/* 获取级联框的编辑信息 */
	@action async getContentInfo(params, status = 'edit') {
		try {
			let res = await services.getRequest(
				services.requestUrl.getServeInfo,
				params
			);
			if (isDataExist(res)) {
				this.info = { ...res.data.data, status };
				this.editVisible = true;
			}
		} catch (error) {
			console.log(error);
		}
	}

	/* 保存 */
	@action async saveMaintain(params) {
		try {
			let res = await services.putRequest(
				services.requestUrl.saveMaintain,
				params
			);
			if (isDataExist(res)) {
				this.getMaintain();
				return res;
			}
		} catch (error) {
			console.log(error);
		}
	}

	/* ------------ 方案 */
	@observable schemeList = [];
	@observable schemePage = { pageIndex: 1, pageSize: 10 };
	@observable resultConfig = []
	@observable modalSelectedKeys = []
	@observable modalLoading = false

	@action async getScheme(params = {}) {
		this.isLoading = true;
		this.schemeList = [];
		this.schemePage = { pageIndex: 1, pageSize: 10 };
		try {
			let data = {
				procedureId: this.procedureId,
				materialId: this.materialId,
				...omit(this.schemePage, 'total'),
				...params
			};
			let res = await services.getRequest(services.requestUrl.getScheme, data);
			this.isLoading = false;
			if (isDataExist(res)) {
				this.schemeList = res.data.data.items;
				this.schemePage = res.data.data.page;
			}
		} catch (error) {
			console.log(error);
		}
	}
	@action async getSchemaInfo(params) {
		try {
			let res = await services.getRequest(
				services.requestUrl.schemaInfo,
				params
			);
			if (isDataExist(res)) {
				this.currentMain = res.data.data;
			}
		} catch (error) {
			console.log(error);
		}
	}
	@action async saveSchema(params) {
		let data = {
			...params
		};
		try {
			let res = await services.putRequest(services.requestUrl.saveSchema, data);
			if (isDataExist(res)) {
				this.getScheme();
				return res;
			}
		} catch (error) {
			console.log(error);
		}
	}
	@action async delSchema(params, type) {
		try {
			let data = {
				...params
			};
			let res = await services.putRequest(services.requestUrl.delSchema, data);
			if (isDataExist(res)) {
				message.success('删除成功');
			}
		} catch (error) {
			console.log(error);
		}
		this.getScheme();
	}

	/* 获取所有的工序下绑定的质检项列表 */
	@action.bound async getConfigByProcedure(params,) {
		this.modalLoading = true;
		try {
			let res = await services.getRequest(
				services.requestUrl.configByProcedure,
				params
			);
			if(this.status === 'add'){
				this.modalLoading = false
			}
			if (isDataExist(res)) {
				for (let item of res.data.data) {
					if(this.status === 'add'){
						item.inspectType = ['first','middle','last'];
						item.first = true
						item.middle = true
						item.last = true
					}
				}
				this.configList = res.data.data;
			}
		} catch (error) {
			console.log(error);
		}
	}
	/* 获取所有的工序下绑定的质检项列表 */
	@action.bound async getConfigByPath(params) {
		try {
			let res = await services.getRequest(
				services.requestUrl.configByPath,
				params
			);
			this.modalLoading = false;
			if (isDataExist(res)) {
				let selectedKeys = []
				for(let item of res.data.data){
					for(let config of this.configList){
						if(config.id === item.inspectItemId){
							let inspectType = []
							if (item.first) inspectType.push('first');
							if (item.middle) inspectType.push('middle');
							if (item.last) inspectType.push('last');
							console.log(item)
							Object.assign(config,{
								first:item.first,
								middle:item.middle,
								last:item.last,
								top:item.top,
								down:item.down,
								standard:item.standard,
								inspectType,
							})
						}
					}
					selectedKeys.push(item.inspectItemId)
				}

				this.modalSelectedKeys = selectedKeys
			}
		} catch (error) {
			console.log(error);
		}
	}
	@action.bound handleInspectType(record, checkedValues,) {
		try {
			let list = JSON.parse(JSON.stringify(this.configList))
			list.map(item => {
				if (item.id === record.id) {
					Object.assign(item, {
						first: checkedValues.indexOf('first') > -1,
						middle: checkedValues.indexOf('middle') > -1,
						last: checkedValues.indexOf('last') > -1,
						inspectType:checkedValues
					});
				}
				return item.id;
			});
			this.configList = list
		} catch (error) {
			console.log(error);
		}
	}
	@action.bound handleNumber(record, type, value) {
		try {
			let list = JSON.parse(JSON.stringify(this.configList))
			list.map(item => {
				if(item.id === record.id){
					Object.assign(item, {
						standard: type === 'standard' ? value : item.standard,
						top: type === 'top' ? value : item.top,
						down: type === 'down' ? value : item.down
					});
				}
				return item.id
			});
			this.configList = list
		} catch (error) {
			console.log(error);
		}
	}

	/* ----------- 计划 */
	@observable checkPlanList = [];
	@observable checkPlanPage = { pageIndex: 1, pageSize: 10 };
	@observable deviceByIdList = [];
	@observable schemaByIdList = [];

	@action async getPlan(params) {
		this.isLoading = true;
		this.checkPlanList = [];
		try {
			let data = {
				...this.checkPlanPage,
				...params
			};
			let res = await services.getRequest(services.requestUrl.getPlan, data);
			this.isLoading = false;
			if (isDataExist(res)) {
				this.checkPlanList = res.data.data.items;
				this.checkPlanPage = res.data.data.page;
			}
		} catch (error) {
			console.log(error);
		}
	}
	@action async getListByType(type, data) {
		try {
			let req = type === 'device' ? 'getDeviceByType' : 'getSchemaByType';
			let params = { typeId: this.deviceType, ...data };
			if (type === 'schema') params.type = this.maintainType;
			let res = await services.getRequest(services.requestUrl[req], params);
			if (isDataExist(res)) {
				if (type === 'device') {
					this.deviceByIdList = res.data.data;
				} else {
					this.schemaByIdList = res.data.data;
				}
			}
		} catch (error) {
			console.log(error);
		}
	}
	@action async savePlan(params) {
		let req = 'savePlan';
		let data = {
			...params
		};
		try {
			let res = await services.putRequest(services.requestUrl[req], data);
			if (isDataExist(res)) {
				this.getPlan();
				return res;
			}
		} catch (error) {
			console.log(error);
		}
	}
	@action async delPlan(params, type) {
		let req = type === 'batch' ? 'batchDelPlan' : 'delPlan';
		try {
			let res = await services.putRequest(services.requestUrl[req], {
				...params
			});
			if (isDataExist(res)) {
				message.success('删除成功');
			}
		} catch (error) {
			console.log(error);
		}
		this.getPlan();
	}
	@action async getPlanInfo(params) {
		this.currentMain = {};
		try {
			let res = await services.getRequest(services.requestUrl.getPlanInfo, {
				...params
			});
			if (isDataExist(res)) {
				this.currentMain = res.data.data;
				return res.data.data.excuteTime;
			}
		} catch (error) {
			console.log(error);
		}
	}
	@action async toDetail(params) {
		try {
			let res = await services.putRequest(services.requestUrl.toDetail, {
				...params
			});
			if (isDataExist(res)) {
				message.success('下发成功');
			}
		} catch (error) {
			console.log(error);
		}
		this.getPlan();
	}

	/* ---------点检操作-------- */
	@observable deviceId = 0;
	@observable op_deviceList = [];
	@observable operateList = [];
	@observable operatePage = { pageIndex: 1, pageSize: 10 };
	@observable listByConfigs = [];
	@observable typeList = [];
	@observable deviceList = [];
	@observable infos = [];
	@observable checkedList = [];
	@observable operateVisible = false;
	@observable contentType = 1

	@action async getDeviceType() {
		try {
			let res = await services.getRequest(services.requestUrl.getDevice);
			if (isDataExist(res)) {
				this.typeList = [{ name: '全部', id: '' }].concat(res.data.data);
			}
		} catch (error) {
			console.log(error);
		}
	}
	@action async getDeviceByType(params) {
		try {
			let res = await services.getRequest(
				services.requestUrl.getDeviceByType,
				params
			);
			if (isDataExist(res)) {
				this.deviceList = [{ name: '全部', id: '' }].concat(res.data.data);
				this.deviceId = '';
			}
		} catch (error) {
			console.log(error);
		}
	}
	@action async getOperateList(params) {
		this.isLoading = true;
		this.operateList = [];
		try {
			let data = {
				...this.operatePage,
				...params,
				result: 1
			};
			let res = await services.getRequest(
				services.requestUrl.getOperateList,
				data
			);
			this.isLoading = false;
			if (isDataExist(res)) {
				this.operateList = res.data.data.items;
				this.operatePage = res.data.data.page;
			}
		} catch (error) {
			console.log(error);
		}
	}
	@action async getListByConfigs(params) {
		this.isLoading = true;
		try {
			let res = await services.getRequest(
				services.requestUrl.getListByConfigs,
				params
			);
			this.isLoading = false;

			if (isDataExist(res)) {
				this.listByConfigs = res.data.data;
			}
		} catch (error) {
			console.log(error);
		}
	}
	@action async saveOperate(params) {
		try {
			let res = await services.putRequest(
				services.requestUrl.saveOperate,
				params
			);
			if (isDataExist(res)) {
				message.success('操作成功');
			}
		} catch (error) {
			console.log(error);
		}
		this.getOperateList();
	}
	@action modifyConfigs({ config, level, data }) {
		try {
			const { contentType } = config;
			if (level === 1) {
				this.listByConfigs.map(item => {
					if (item.id === config.id) {
						Object.assign(item, {
							result:
								contentType === 7
									? data.format('YYYY-MM-DD')
									: [1, 4].includes(contentType)
									? data.target.value
									: data
						});
					}
				});
			}
		} catch (error) {}
	}

	/* ----------查询---------- */
	@observable result = 0;
	@observable typeId = 0;
	@observable deviceId = 0;
	@observable queryList = [];
	@observable queryPage = { pageIndex: 1, pageSize: 10 };
	@observable resultDetail = [];
	@observable resultNum = 0
	@observable resultVisible = false;
	@observable columns = []
	@observable resultStart = ''
	@observable resultEnd = ''

	@action async getQuery(params) {
		this.queryList = [];
		this.isLoading = true;
		try {
			let data = {
				...this.queryPage,
				type:this.contentType,
				materialId:this.materialId, 
				procedureId:this.procedureId, 
				startDate:this.resultStart,
				endDate:this.resultEnd,
				...params
			};
			let res = await services.getRequest(
				services.requestUrl.getQuery,
				data
			);
			this.isLoading = false;
			if (isDataExist(res)) {
				this.queryList = res.data.data.items;
				this.queryPage = res.data.data.page;
			}
		} catch (error) {
			console.log(error);
		}
	}
	@action async getResultInfo(params) {
		this.isLoading = true;
		try {
			let res = await services.getRequest(
				services.requestUrl.getResultInfo,
				params
			);
			this.isLoading = false;
			if (isDataExist(res)) {
				let data = res.data.data,list = [];
				this.resultNum = res.data.data[0].infos.length;
				for(let i=0;i<data.length;i++){
					let item=data[i];
					for(let j=0;j<data[i].infos.length;j++){
						Object.assign(item,{
							...data[i].infos[j],
							['actural'+j] : data[i].infos[j].actural
						})
					}
					list.push(item)
				}
				console.log(list)
				this.resultDetail = list
				return true;
			}
		} catch (error) {
			console.log(error);
			return false;
		}
	}

	@action clearData() {
		this.result = 0;
		this.materialId = '';
		this.procedureId = '';
		this.queryList = [];
		this.queryPage = {};
		this.editVisible = false;
		this.currentMain = {};
		this.info = {};
	}

	@action.bound modifyValue(key, value) {
		this[key] = value;
	}
}

let InspectStore = new Inspect();
export default InspectStore;
